import WalletPayments from './WalletPayments';

export default WalletPayments;
